document.addEventListener( 'DOMContentLoaded', () => {
	document
		.querySelectorAll( '.boilpress-accordions' )
		.forEach( ( container ) => {
			container.addEventListener( 'click', ( event ) => {
				const button = event.target.closest(
					'.boilpress-accordion-button'
				);
				if ( ! button ) return; // Ignore clicks outside buttons

				const accordion = button.closest( '.boilpress-accordion' );
				const isExpanded =
					accordion.getAttribute( 'aria-expanded' ) === 'true';

				container
					.querySelectorAll( '.boilpress-accordion' )
					.forEach( ( acc ) => {
						acc.setAttribute(
							'aria-expanded',
							acc === accordion ? ! isExpanded : false
						);
					} );
			} );
		} );
} );
